import { Checkbox, Fieldset } from '@servicetitan/anvil2-react-hook-form';
import { MailingAddressFields } from '../mailing-address/MailingAddressFields';
import { IsAddressSameAsPrimaryFieldWatcher } from './IsAddressSameAsPrimaryFieldWatcher';
import { SpouseFormFields } from '../spouseInfo';
import { useFormContext } from 'react-hook-form';

interface CoApplicantMailingAddressFieldsProps {
    primaryApplicantState: string;
}

export const CoApplicantMailingAddressFields = ({
    primaryApplicantState,
}: CoApplicantMailingAddressFieldsProps) => {
    const { watch } = useFormContext();
    // Watch co-applicant state to determine spouse information needs when they have a different address
    const coApplicantState = watch('coApplicant.address.state') as string | undefined;

    return (
        <Fieldset legend="Mailing Address">
            <Checkbox
                name="coApplicant.isAddressSameAsPrimary"
                label="Same as applicant mailing address"
                gridColumn="1/3"
            />
            <IsAddressSameAsPrimaryFieldWatcher>
                {isAddressSameAsPrimary => {
                    // Use primary's state if address is same, otherwise use co-applicant's own state
                    const effectiveState = isAddressSameAsPrimary
                        ? primaryApplicantState
                        : coApplicantState;

                    return (
                        <>
                            {!isAddressSameAsPrimary && (
                                <div style={{ gridColumn: '1 / -1' }}>
                                    <MailingAddressFields fieldPrefix="coApplicant" />
                                </div>
                            )}
                            <div style={{ gridColumn: '1 / -1' }}>
                                <SpouseFormFields
                                    applicantType="co-applicant"
                                    state={effectiveState}
                                    context="mailing-address"
                                />
                            </div>
                        </>
                    );
                }}
            </IsAddressSameAsPrimaryFieldWatcher>
        </Fieldset>
    );
};
